import { EventEmitter, Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { UserClaims, User } from '@mitel/cloudlink-sdk';

import { environment } from '../../../environments/environment';
import { UsersService } from './users.service';
import { PolicyTestRequest } from '@mitel/cloudlink-sdk/authentication';
import { AuthService } from './auth.service';
import { UserUtil } from '@mitel-internal/cloudlink-components-catalogue';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})

// this service will talk to the policy component to determine the user's policies
export class PolicyToggleService {

	gwpIntegrationAllowed: boolean = false;

	constructor( private userSvc: UsersService, private authSvc: AuthService ) 
	{
	}

	requestGWPIntegrationPolicy() {
		if (!this.userSvc.me) {
			return new Promise<boolean>((resolve, reject) => {
				this.userSvc.getMe().subscribe(async u => {
					resolve(this.runMiAccessPolicyTest(u));
				});
			});
		} else {
			return this.runMiAccessPolicyTest(this.userSvc.me);
		}
	}

	async runMiAccessPolicyTest(user): Promise<boolean> {
		let policyRequest: PolicyTestRequest;
		
		if (user.error) {
			console.error('Error getting user:', user.error);
			this.gwpIntegrationAllowed = false;
			return this.gwpIntegrationAllowed;
		}

		// If user is a Miaccess user then they will need to check policy
		if ((<User>user).createdBy === 'Mitel Connect') {
			policyRequest = { 
				resources: [{
					resource: 'https://mitel.io/auth/gateway-portal/licenses/login',
					action: '*'
				}]
			};		
		} else {
			this.gwpIntegrationAllowed = true;
			return this.gwpIntegrationAllowed;
		}
		
		let response;
		try {
			response = await this.authSvc.testPolicy(policyRequest);
		} catch (err) {
			console.error('Cannot run policy test:', err);
			this.gwpIntegrationAllowed = false;
			return this.gwpIntegrationAllowed;
		}
		
		let policy = response.results[0];

		if (policy.effect === 'ExplicitAllow') {
			this.gwpIntegrationAllowed = true;
			return this.gwpIntegrationAllowed;
		}
		
		this.gwpIntegrationAllowed = false;
		return this.gwpIntegrationAllowed;
	}
	

	hasGWPAccess() {
		return this.gwpIntegrationAllowed;
	}
}
